import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createBasePlugin } from 'wix-rich-content-plugin-commons';
import createMentionPlugin from 'draft-js-mention-plugin';
import { positionSuggestions } from './positionSuggestions';
import { MENTION_TYPE } from 'wix-rich-content-common';
import pluginStyles from './styles.scss';
/** Provides the mention plugin base config. We use draft-js-mention-plugin under the hood. */ function externalMentionPluginCreator(pluginConfig) {
    const externalMentionPluginInstance = createMentionPlugin(_object_spread({
        entityMutability: 'IMMUTABLE',
        mentionPrefix: '@',
        theme: pluginStyles,
        positionSuggestions: positionSuggestions(pluginConfig)
    }, pluginConfig));
    const MentionSuggestions = externalMentionPluginInstance.MentionSuggestions;
    const MentionPortal = (props)=>{
        useEffect(()=>{
            const container = document.getElementById('editor-mention-portal');
            if (!container) {
                const el = document.createElement('div');
                el.id = 'editor-mention-portal';
                document.body.appendChild(el);
            }
        });
        const container = document.getElementById('editor-mention-portal');
        if (!container) {
            return null;
        }
        return /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ React.createElement(MentionSuggestions, props), container);
    };
    return {
        extras: {
            MentionSuggestions: MentionPortal
        },
        plugin: (config)=>{
            const type = MENTION_TYPE;
            const { decorator, helpers, theme, isMobile, t, [type]: settings = {} } = config, rest = _object_without_properties(config, [
                "decorator",
                "helpers",
                "theme",
                "isMobile",
                "t",
                type
            ].map(_to_property_key));
            return createBasePlugin(_object_spread({
                decorator,
                theme,
                type,
                helpers,
                isMobile,
                t,
                settings: _object_spread_props(_object_spread({}, settings), {
                    MentionSuggestions: MentionPortal
                }),
                defaultPluginData: {}
            }, rest), externalMentionPluginInstance);
        }
    };
}
export { externalMentionPluginCreator };
